import React, { Component } from 'react';
import { trackClick, event, cat, custom } from 'common/utils/instrumentation';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  userInfoSelector,
  listCitiesSelector,
  isCashlessPaymentDisabledSelector,
  isCashPaymentDisabledSelector,
} from 'selectors/app-selector';
import {
  paymentMethodSelector,
  bulkUploadProcessingSelector,
} from 'selectors/booking-selectors';
import { getCompanyID } from 'helper/user';
import { isPaxUser } from 'helper/grab-id-auth-helper';
import {
  fetchServiceTypesActionV2,
  paxFetchServiceTypesAction,
  fetchQuoteActionV2,
  getAddressTranslationAction,
  processBulkUploadDataActionV2,
} from 'actions/booking-actions';
import {
  scribeTrackEvent,
  getCommonFacet,
  SCRIBE_STATE_NAMES,
  SCRIBE_BULK_UPLOAD_MODAL_EVENTS,
} from 'applications/scribe/instrumentations/track';

import UploadSpreadsheetModal, {
  UPLOAD_SPREADSHEET_MODAL_ID,
} from './upload-spreadsheet-modal';
import DownloadTemplateModal from './download-template-modal';

class SpreadsheetModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadModalVisible: false,
    };
  }

  onToggleDownloadModal = () => {
    const { userInfo } = this.props;
    const { downloadModalVisible } = this.state;
    trackClick(
      event.BULK_UPLOAD_CLICKS,
      cat.GE_BULK_UPLOAD,
      'DOWNLOAD_TEMPLATE',
      {
        [custom.COMPANY_ID]: getCompanyID(userInfo),
      },
    );
    scribeTrackEvent({
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_WEB,
      eventName: SCRIBE_BULK_UPLOAD_MODAL_EVENTS.DOWNLOAD_TEMPLATE,
      facets: getCommonFacet(userInfo),
    });

    try {
      const uploadModal = document.getElementById(UPLOAD_SPREADSHEET_MODAL_ID)
        .parentElement;
      uploadModal.style.display = downloadModalVisible ? 'block' : 'none';
    } catch (e) {
      // do nothing
    }
    this.setState({ downloadModalVisible: !downloadModalVisible });
  };

  getCity = () => {
    const { userInfo: { selectedCity } } = this.props;
    return {
      name: selectedCity.city,
      code: selectedCity.cityCode,
      poi: selectedCity.cityPOI,
      ...selectedCity,
    };
  };

  fetchServiceTypes = (cityID, callback) => {
    if (isPaxUser()) {
      const { paxFetchServiceTypes } = this.props;
      paxFetchServiceTypes(cityID, callback);
    } else {
      const { userInfo, fetchServiceTypes } = this.props;
      fetchServiceTypes(cityID, getCompanyID(userInfo), callback);
    }
  };

  render() {
    const { downloadModalVisible } = this.state;
    const {
      visible,
      userInfo,
      cities,
      onCancel,
      processBulkUploadData,
      bulkUploadProcessing,
      isCashlessPaymentDisabled,
      isCashPaymentDisabled,
      payments,
    } = this.props;
    const city = this.getCity();

    return (
      <div>
        <UploadSpreadsheetModal
          visible={visible}
          onCancel={onCancel}
          hideModal={onCancel}
          onDownload={this.onToggleDownloadModal}
          processBulkUploadData={processBulkUploadData}
          bulkUploadProcessing={bulkUploadProcessing}
          userInfo={userInfo}
        />
        <DownloadTemplateModal
          visible={downloadModalVisible}
          userInfo={userInfo}
          cities={cities}
          city={city}
          onCancel={this.onToggleDownloadModal}
          hideModal={this.onToggleDownloadModal}
          fetchServiceTypes={this.fetchServiceTypes}
          isCashlessPaymentDisabled={isCashlessPaymentDisabled}
          isCashPaymentDisabled={isCashPaymentDisabled}
          payments={payments}
        />
      </div>
    );
  }
}

SpreadsheetModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  userInfo: PropTypes.shape({}).isRequired,
  cities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  fetchServiceTypes: PropTypes.func.isRequired,
  paxFetchServiceTypes: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  processBulkUploadData: PropTypes.func.isRequired,
  bulkUploadProcessing: PropTypes.shape({}).isRequired,
  isCashlessPaymentDisabled: PropTypes.bool.isRequired,
  isCashPaymentDisabled: PropTypes.bool.isRequired,
  payments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

SpreadsheetModal.defaultProps = {
  payments: [],
};

const mapStateToProps = state => ({
  userInfo: userInfoSelector(state),
  cities: listCitiesSelector(state),
  payments: paymentMethodSelector(state),
  bulkUploadProcessing: bulkUploadProcessingSelector(state),
  isCashlessPaymentDisabled: isCashlessPaymentDisabledSelector(state),
  isCashPaymentDisabled: isCashPaymentDisabledSelector(state),
});

const mapDispatchToProps = {
  fetchServiceTypes: fetchServiceTypesActionV2,
  paxFetchServiceTypes: paxFetchServiceTypesAction,
  fetchQuotes: fetchQuoteActionV2,
  getAddressTranslation: getAddressTranslationAction,
  processBulkUploadData: processBulkUploadDataActionV2,
};

export default connect(mapStateToProps, mapDispatchToProps)(SpreadsheetModal);
